import React from "react";
import { Grid, Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { Location, LocationPosition } from "@src/Interfaces/Entity/Location";
import { observer, inject } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { STWrapper, CSTPaper, STEmptyAdd } from "./styles";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import _ from "lodash";
import CrewTableContent from "../CrewTableContent/CrewTableContent";
import { Position } from "@src/Interfaces/Entity/Position";
import { CrewPosition } from "@src/Interfaces/Entity/Crew";
import { PositionAssignment } from "../../../../../../Interfaces/Entity/Person/index";

interface IProps {
  location: Location;
  values?: IValuesStore;
  management?: IManagementStore;
  noTitle?: boolean;
}

@inject("values", "management")
@observer
export default class CrewTable extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  getActivelyAssignedPosition = (positionAssignments: PositionAssignment[], position: Position) => {
    return positionAssignments.find(
      pa => pa.activelyAssigned && pa.positionId === position.id && pa.locationId === this.props.location.id
    );
  };

  getPositions = (): CrewPosition[] => {
    const { activePositions, activePersons } = this.props.management;
    const { location: currentLocation } = this.props;
    const crewPositions = activePositions.filter((activePosition: Position) =>
      currentLocation.locationPositions.find(
        (locationPosition: LocationPosition) => activePosition.id === locationPosition.positionId
      )
    );

    return (crewPositions || []).map((position: Position) => {
      const crewPosition = _.cloneDeep(position) as CrewPosition;
      const activelyAssignetPerson = activePersons.find(person =>
        this.getActivelyAssignedPosition(person.positionAssignments, position)
      );
      if (!activelyAssignetPerson) {
        return crewPosition;
      }
      crewPosition.activelyAssignetPersonName = activelyAssignetPerson.fullName;
      const { activelyAssignedSince, switchedByName } = this.getActivelyAssignedPosition(
        activelyAssignetPerson.positionAssignments,
        position
      );
      crewPosition.activelyAssignedSince = activelyAssignedSince;
      crewPosition.switchedByName = switchedByName;
      return crewPosition;
    });
  };

  render() {
    let positions = this.getPositions();
    return (
      <STWrapper>
        {!this.props.noTitle && (
          <Grid container>
            <Grid item xs>
              <STFormTitleTypography>{Values.getLocalizationValue("crew")}</STFormTitleTypography>
            </Grid>
            <Grid item>
              <STFormTitleTypography>{this.props.location.name}</STFormTitleTypography>
            </Grid>
          </Grid>
        )}
        {positions.length === 0 && (
          <STEmptyAdd>
            <ResultsAreEmpty />
          </STEmptyAdd>
        )}
        {positions.length > 0 && (
          <CSTPaper elevation={2}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <STTableHeadTypography>{Values.getLocalizationValue("position")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell>
                    <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell>
                    <STTableHeadTypography>{Values.getLocalizationValue("assignedSince")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell align="center">
                    <STTableHeadTypography>{Values.getLocalizationValue("options")}</STTableHeadTypography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {positions.map((position: CrewPosition) => (
                  <CrewTableContent key={position.id} position={position} location={this.props.location} />
                ))}
              </TableBody>
            </Table>
          </CSTPaper>
        )}
      </STWrapper>
    );
  }
}
